import useTranslation from 'hooks/useTranslation'
import place from 'assets/img/place.webp'
import React from 'react'
import './style.scss'

const PlaceTemplatePhoto: React.FC = () => {
  const { t } = useTranslation('map')
  return (
    <div className='templatePhoto__container'>
      <img
        alt=''
        src={place}
      />
      <div className='templatePhoto__content'>
        <div className='templatePhoto__title --secFont'>{t('illustrativeVisualization')}</div>
        <div className='templatePhoto__subtitle'>{t('photoDoesNotShowOfferedStorageUnits')}</div>
      </div>
    </div>
  )
}

export default PlaceTemplatePhoto